import pro1 from "../pictures/pro1.jpg"
import pro2 from "../pictures/pro2.jpg"
import pro3 from "../pictures/pro3.jpg"
import pro4 from "../pictures/pro4.png"
// import todo from "../pictures/todo.png"
const ProjectCardData =[
    {
        id: 0,
        imgsrc: pro1,
        title: "Weather-App",
        text:"Real-time weather information around the world. Incorporated location detection, current weather information, and daily forecasts with temperature readings.",
        view: "https://weatherappsb.netlify.app/",
        source: "https://github.com/SimunBiswas/WeatherApp.git",

    },
     {
        id: 1, 
        imgsrc: pro4,
        title: "Spotify Chatbeats",
        text:"Node.js, Mongodb, Next.js used & created a responsive real-time spotify Chatting app.",
        view: "https://realtimespotifysimun.netlify.app",
        source: "https://github.com/SimunBiswas/Realtime-Spotify.git",

    },
    {
        id: 2, 
        imgsrc: pro2,
        title: "E-Commerce Website",
        text:"React.js and bootstrap used and created a responsive e-commerce website, with thw functionality of multiple pages. React-Redux is used to create store. ",
        view: "https://ecommercewebsitesimunbiswas.netlify.app/",
        source: "https://github.com/SimunBiswas/e-comm",

    },
     {
        id: 3, 
        imgsrc: pro3,
        title: "Snake Game",
        text:"In this App users can have the experience of classic snake game. Eat the food and the snake will grow. ",
        view: "https://snakegames123.netlify.app/",
        source: "https://github.com/SimunBiswas/Snake-Game",

    },
    
]

export default ProjectCardData;

